import React, { useState } from "react";
import { AiOutlineCloseSquare, AiFillEye } from "react-icons/ai";
import { toast } from "react-toastify";
import { MyContextSupply } from "../../Context";
import { useNavigate } from "react-router-dom";
import { AiFillEyeInvisible } from "react-icons/ai";

const AdminValidation = ({
  handleClose,
  isAdminRouteClick,
  setIsAdminRouteClick,
  inputValue,
  setInputValue,
  setDrawerOpen,
}) => {
  const navigate = useNavigate();
  const { setAdminValidationRun, toggleRunPath } = MyContextSupply();
  const [isPinVisible, setIsPinVisible] = useState(false);

  const adminSecret = process.env.REACT_APP_ADMIN_SECRET;

  const inputOnChangeGetValue = (e) => {
    const value = e.target.value;
    setInputValue(value);
  };

  const OnSubmit = (e) => {
    e.preventDefault();
    if (inputValue !== "" && inputValue === adminSecret) {
      toast.success("Admin verified!", {
        position: "top-center",
        autoClose: 3000,
      });
      localStorage.setItem("isValidateAdmin", "verified");
      setAdminValidationRun(1);
      setIsAdminRouteClick(false);
      handleClose(false);
      toggleRunPath();
      setDrawerOpen(false);
      const autoTimeNaviate = setTimeout(() => {
        navigate("/admin");
      }, 1000);
      return () => {
        clearTimeout(autoTimeNaviate);
      };
    } else if (inputValue === "") {
      toast.warn("Input field value is empty!", {
        position: "top-center",
        autoClose: 3000,
      });
      setIsAdminRouteClick(false);
    } else {
      toast.warn("Admin not verified! Pin doesn't matched!", {
        position: "top-center",
        autoClose: 3000,
      });
      setIsAdminRouteClick(false);
    }
  };

  return (
    <div
      className={`nav-admin-validation-form ${
        isAdminRouteClick && "show-nav-admin-validation-form"
      }`}
    >
      <div>
        <div style={{ position: "relative" }}>
          <p onClick={() => setIsAdminRouteClick(false)}>
            <AiOutlineCloseSquare className="pos-admin-validation-close-btn" />
          </p>
        </div>
        <form
          onSubmit={OnSubmit}
          className="form-review bg-validation-form-admin"
        >
          <p>Give Admin Secret Pin</p>
          <div style={{ position: "relative" }}>
            <input
              value={inputValue}
              onChange={inputOnChangeGetValue}
              type={`${isPinVisible ? "text" : "password"}`}
              className="input-admin-verify"
              autoComplete="off"
            />
            <p
              onClick={() => setIsPinVisible(!isPinVisible)}
              className="eye-adminpin-form"
            >
              {isPinVisible ? <AiFillEye /> : <AiFillEyeInvisible />}
            </p>
          </div>
          <button type="submit" className="btn-review-submit">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminValidation;
